import {BLOCK_SCREEN_WITH_MESSAGE} from "../core/const";

export const blockScreenWithMessage = (message) => ({
    type: BLOCK_SCREEN_WITH_MESSAGE,
    message,
});

export function fireBlockScreenWithMessage(message) {
    return (dispatch) => {
        return dispatch(blockScreenWithMessage(message));
    };
}